import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tyre-issue-layout',
  templateUrl: './tyre-issue-layout.component.html',
  styleUrls: ['./tyre-issue-layout.component.css']
})
export class TyreIssueLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
